import React from 'react';
import { Bars3Icon } from '@heroicons/react/24/outline';

const TopBar = ({ onMenuClick }) => {
  return (
    <header className="bg-black border-b border-[#2c2c2c] hidden lg:hidden">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 justify-between items-center">
          <div className="flex items-center">
            <button
              type="button"
              className="p-2 rounded-md text-gray-400 hover:text-white focus:outline-none"
              onClick={onMenuClick}
            >
              <span className="sr-only">Open sidebar</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default TopBar; 